interface DateCellProps {
  value?: string | Date | null;
}

export function DateCell({ value }: DateCellProps) {
  if (!value) return <span>-</span>;
  const d = new Date(value);
  // Se mostrará en la zona horaria local del navegador
  const formatted = d.toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
  return <span>{formatted}</span>;
}






